// constants

// action_component_subject
const APPEND_BOOKING_LIST = "APPEND_BOOKING_LIST";

// reducers

const initialState = [];

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case APPEND_BOOKING_LIST:
			return [...state, action.payload];

		default:
			return state;
	}
};

export default Reducer;

// actions

// const resolveAfter2Seconds = () => {
// 	return new Promise((resolve) => {
// 		setTimeout(() => {
// 			resolve("resolved");
// 		}, 2000);
// 	});
// };

// action_component_subject
// export const decrementTestCounter = () => async (dispatch) => {
// 	const result = await resolveAfter2Seconds();
// 	console.log(result);
// 	dispatch({
// 		type: INCREMENT_TEST_COUNTER,
// 	});
// };

// action_component_subject, prefix set(not update),empty(not remove),hide,show
export const appendBookingListDevice = (booking) => {
	return {
		type: APPEND_BOOKING_LIST,
		payload: booking,
	};
};
